import React, { useContext } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { AuthContext } from './contexts/AuthContext';

import Home from './components/Home';
import FullScreenLoader from './components/FullScreenLoader';
import Header from './components/Header';
import { getStoredValue } from './utils';
import * as qs from 'query-string';

const App = () => {
  const { username, jwtToken } = useContext(AuthContext);
  const location = useLocation();

  if (username && jwtToken) {
    const storedQueryParams = getStoredValue('queryParams');
    const currentQueryParams = qs.parse(location.search);

    let wellName = null;
    let reportName = null;

    if (currentQueryParams.wellName) {
      wellName = currentQueryParams.wellName;
    } else if (storedQueryParams.wellName) {
      wellName = storedQueryParams.wellName;
    }
    if (currentQueryParams.reportName) {
      reportName = currentQueryParams.reportName;
    } else if (storedQueryParams.reportName) {
      reportName = storedQueryParams.reportName;
    }

    return (
      <div className="min-w-full min-h-screen">
        <Header></Header>
        <Switch>
          <Route path="/">
            <Home wellName={wellName} reportName={reportName} />
          </Route>
        </Switch>
      </div>
    );
  } else {
    return <FullScreenLoader></FullScreenLoader>;
  }
};

export default App;
